import { useTranslation } from "react-i18next";

import { cx } from "@/lib/utils";

/**
 * Forgmatic wordmark + logo. The PNG asset (`/forgmatic-logo.png`)
 * is the canonical brand glyph from the design handoff. We size it
 * relative to the surrounding text height so the lockup scales with
 * the parent font.
 */
interface BrandLogoProps {
  /** Show the wordmark next to the glyph. Defaults to true. */
  showWordmark?: boolean;
  className?: string;
}

export function BrandLogo({
  showWordmark = true,
  className,
}: BrandLogoProps): JSX.Element {
  const { t } = useTranslation("common");
  const name = t("app.name");
  return (
    <span
      aria-label={name}
      className={cx("inline-flex items-center gap-2 text-current", className)}
    >
      <img
        src="/forgmatic-logo.png"
        alt=""
        aria-hidden="true"
        className="h-[1.4em] w-[1.4em] shrink-0 object-contain"
      />
      {showWordmark && (
        <span className="font-semibold tracking-tight">{name}</span>
      )}
    </span>
  );
}
